import React, { useState } from 'react';
import { splitPdf } from '../community-hats-js-library/utils/labFunctions';

import { Upload, Button, message, Card, Progress, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions.js';
import { RefContextLanguage } from '../providers/LanguageProvider';



function FileSplitter() {

    const i18n = RefContextLanguage()

    // Splitter
    const [largePDF, setLargePDF] = useState(null)
    const [isSplittingPDF, setIsSplittingPDF] = useState(false)
    const [splittingProgress, setSplittingProgress] = useState(0)
    const [totalReports, setTotalReports] = useState(null)


    const splitPDF = async () => {

        setSplittingProgress(0)
        setTotalReports(null)


        await new Promise(resolve => setTimeout(resolve, 0)); // Let React update


        if (!largePDF) {
            message.error(i18n.t('noFileSelected'));
            return;
        }


        setIsSplittingPDF(true)

        const fileBytes = await largePDF.arrayBuffer();

        let total = await splitPdf(fileBytes, (prog) => setSplittingProgress(prog))
        setTotalReports(total)

        setIsSplittingPDF(false)
        setSplittingProgress(100)


    }


    return (
        <Card style={{ width: "40vw" }}
            styles={{ header: { backgroundColor: "var(--primary-color-1)" } }}
            type="inner" size="small" title={i18n.t('splitLargePdf')} >


            <Upload
                beforeUpload={(uploadedFile) => {
                    setLargePDF(uploadedFile); // Store the uploaded file
                    setSplittingProgress(0)
                    setTotalReports(null)

                    return false; // Prevent automatic upload
                }}
                showUploadList={false} // Hide default file list
            >
                <Button icon={<UploadOutlined />}>{i18n.t('clickToUpload')}</Button>
            </Upload>

            {
                !isNullOrUndefined(largePDF)
                    ? <p style={{ marginTop: "10px" }}>{i18n.t('selectedFile')}: {largePDF.name}</p>
                    : <div style={{ marginTop: "10px" }}></div>
            }

            {/* Process File Button */}
            {
                isSplittingPDF
                    ? <Spin />
                    : <Button
                        type="primary"
                        style={{ marginTop: "10px" }}
                        onClick={splitPDF}
                    >
                        Split PDF
                    </Button>
            }
            {
                splittingProgress === 100 && !isNullOrUndefined(totalReports)
                    ? <div>
                        <p style={{ marginTop: "10px" }}>{i18n.t('totalReports')}: {totalReports} </p>

                    </div>
                    : <div style={{ height: "30px" }}></div>
            }

            <Progress style={{ width: "100%" }} percent={splittingProgress} status='success' />


        </Card>

    )
}

export default FileSplitter